export default "__VITE_ASSET__4dzjjc$i__"